import { AddToCartButton } from "../cart/index.js";
import { Box, Container, Slide, Typography, useTheme } from "@mui/material";
import { LocalizationContext } from "../localization/index.js";
import { makeCurrencyFormatter, price } from "./utils.js";
import { ProductContext } from "./provider.js";
import { useTranslation } from "next-i18next";
import React from "react";
export const StickyAddToCart = ({ show }) => {
    const { t } = useTranslation("c-product");
    const theme = useTheme();
    const product = React.useContext(ProductContext);
    const { market } = React.useContext(LocalizationContext);
    const { amount, currency } = price({ product, market: market });
    const formatCurrency = makeCurrencyFormatter({ currency });
    return (React.createElement(Slide, { direction: "up", in: show, mountOnEnter: true, unmountOnExit: true },
        React.createElement(Box, { id: "sticky-product-add-to-cart", sx: {
                background: "white",
                bottom: 0,
                boxShadow: "0 1.5rem 5rem #0000001a",
                left: 0,
                pb: 1,
                position: "fixed",
                pt: 1.5,
                width: "100%",
                zIndex: 30,
            } },
            React.createElement(Container, { maxWidth: "xl" },
                React.createElement(AddToCartButton, { buttonProps: {
                        fullWidth: true,
                        id: "sticky-add-to-cart-btn",
                        size: "small",
                        variant: "contained",
                    }, external: false, label: t("sticky-add-to-cart-label", "In den Warenkorb –  {{amount}}", {
                        amount: formatCurrency(amount),
                    }), productId: product.storeId }),
                React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        mt: { xs: 0.5 },
                    } },
                    React.createElement(Typography, { component: "div", sx: {
                            color: theme.palette.grey[600],
                            flexShrink: 0,
                            fontFamily: theme.sansSerifFontFamily,
                            fontSize: "0.75rem",
                            pt: 0,
                            pb: 0,
                        }, variant: "caption" }, t("stick-cart-subheadline", "inkl. MwSt. | kostenloser Versand")))))));
};
//# sourceMappingURL=sticky-add-to-cart.js.map